export default __webpack_public_path__ + "static/media/offer-vertical-chocolate-lyte@3x.031085d5.png";